module.exports = __webpack_public_path__ + "media/images/homepage_bottom-149bf2fd4f13d35a366438fb6416388e.jpeg";